import { IReduxState } from '../interfaces/IReduxState'

const initialState: IReduxState = {
  pageTitle: '',
  isSideDrawerOpen: false,
  userGroups: [],
  groupAccessMapping: {},
  signInStatus: 'SIGNED_OUT',
  currentUser: {},
}

export const reducer = (
  state: IReduxState = initialState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case 'SET_PAGE_TITLE':
      return { ...state, pageTitle: action.payload }
    case 'OPEN_SIDEDRAWER':
      return { ...state, isSideDrawerOpen: true }
    case 'CLOSE_SIDEDRAWER':
      return { ...state, isSideDrawerOpen: false }
    case 'SET_GROUP_ACCESS_MAPPING':
      return { ...state, groupAccessMapping: action.payload }
    case 'SET_USER_GROUPS':
      return { ...state, userGroups: action.payload }
    case 'SIGN_IN_STATUS':
      return { ...state, signInStatus: action.payload }
    case 'SET_CURRENT_USER':
      return { ...state, currentUser: action.payload }
    default:
      return state
  }
}
